import styled from 'styled-components';

export default styled.div`
  display: flex;
  color: #f6fdff;
  font-size: 14px;
  margin-bottom: 5px;
`;
